import React, { Component } from 'react';
import { connect } from "react-redux";
import { auth } from '../../../config/firebase';
import { Field, reduxForm } from 'redux-form';
import './register.css';
import { startup, register } from '../../../redux/actions';

import Background from '../../assets/registerBg.jpg';
import { ShortField, PasswordRegister } from '../../atoms/formElements/formElements';
import Button from '../../atoms/button/button';

const registerInfo = [
  {
    icon: "cloud-outline",
    title: "Take a deep breath!",
    text: "Office environment is important, we spend so much time in it. That's why we upgradet our building with TakeAir to bring favorable nature inside. This more natural indoor environment is your extra comfort.  "
  },
  {
    icon: "hand",
    title: "High five a co-worker.",
    text: "Getting recognition for the things you do good, we all love it! Help improve the office atmosphere by patting a co-worker on the back and earn points whenever a colleague does the same with you!"
  },
  {
    icon: "emoticon",
    title: "We care about how you feel!",
    text: "Having a way of letting management know how you feel, anonymously, has a big impact on your work-happiness! Give feedback on how we can improve things around you, even daily if you'd like!"
  },
  {
    icon: "share-variant",
    title: "Be connected with the building and your personal environment!",
    text: "Personalize this dashboard to your own liking by centralizing all your important links, whether it's access to healthy food or transportation choices, everything is possible. Make your dashboard a true tool of productivity and health!"
  }
]

class Register extends Component {
  componentDidMount(){
    this.props.match && this.props.startup(this.props.match.params.customerId)
  }
  formSubmit = (values) => {
    const { customerId, id } = this.props.match.params;
    this.props.register(customerId, id, values)
  }
  render() {
    const { state, handleSubmit, customerId, companyInfo } = this.props;
    if(customerId === null){
      return null
    } else {
      return (
        <div id='registerPage' >
          <div className='left' style={{ backgroundImage: `url(${Background})`, backgroundSize: 'cover', backgroundPosition: 'center' }} >
            <div className='wrapper'>
              <h3>What can you expect?</h3>
              <p>First of all, welcome! You received an invitation to this platform because we believe employee happiness is essential in the company culture! This tool will keep track of just that! How? </p>
              <div className='registerPoints'>
                {this.renderPoints()}
              </div>
            </div>
          </div>
          <div className='right'>
            <img alt="logo" className='logoMedium center' src={companyInfo.logo}></img>
            <h2>Let's get you started!</h2>
            <form onSubmit={handleSubmit(this.formSubmit)}>
              <Field name='email' label='Email' component={ShortField} type='text' />
              <div className='flex'>
                <Field name='nameF' label='First name' component={ShortField} type='text' />
                <Field name='nameL' label='Last name' component={ShortField} type='text' />
              </div>
              <Field name='password' label='Password' component={PasswordRegister} type='password' screen='register' />
              <Button label='Register' disabled='false' type='submit' />
            </form>
          </div>
        </div>
      )
    }
  }
  renderPoints() {
    return registerInfo.map(item => {
      return (
        <div className='item' key={item.title}>
          <div className={`mdi mdi-${item.icon}`} />
          <div className='text'>
            <p className='bold'>{item.title}</p>
            <p>{item.text}</p>
          </div>
        </div>
      )
    })
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    companyInfo: state.general.company.info,
    customerId: state.general.company.customerId,
    validatingCustomer: state.general.validatingCustomer,
  };
}

export default reduxForm({
  // validate,
  form: 'signInForm',
})( connect(mapStateToProps, { register, startup })(Register));
